import { Action } from '@/redux/types';

import { TraitsState, SET_TRAITS_DASHBOARD_SLUG } from './types';

const initialState: TraitsState = {
  dashboardSlug: ''
};

export default (state = initialState, { type, payload }: Action): TraitsState => {
  switch (type) {
    case SET_TRAITS_DASHBOARD_SLUG: {
      return { ...state, dashboardSlug: payload.dashboardSlug };
    }
    default:
      return state;
  }
};
